import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { HTTP_SKIP_GLOBAL_LOADING } from './http-skip-global-loading.token';
import { LoadingService } from '../services/loading.service';

/**
 * Interceptor HTTP per la gestione automatica del loading.
 *
 * Questo interceptor:
 * - Avvia il loading quando inizia una richiesta HTTP
 * - Ferma il loading quando la richiesta termina (successo o errore)
 * - Gestisce correttamente le richieste multiple simultanee
 * - Non mostra il loading per richieste che completano rapidamente (< 500ms)
 * - Rispetta `HTTP_SKIP_GLOBAL_LOADING` (es. health `/up` Riprova connectivity)
 */
export const loadingInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const loadingService = inject(LoadingService);
  const skipGlobalLoading = req.context.get(HTTP_SKIP_GLOBAL_LOADING);

  if (!skipGlobalLoading) {
    loadingService.startLoading();
  }

  return next(req).pipe(
    finalize(() => {
      if (!skipGlobalLoading) {
        loadingService.stopLoading();
      }
    })
  );
};
